<template>
  <div
    class="content register-body content-login-block w-100 h-100 d-flex justify-content-center align-items-center flex-column position-relative"
  >
    <div class="logo-top">
      <router-link to="/">
        <img :src="logo" class="logo-top my-5" />
      </router-link>
    </div>
    <div class="row content-body login-body align-items-center">
      <div class="col-lg-12 my-4">
        <div class="row gap-3 flex-nowrap cards-login">
          <div class="col-lg-4 col-5 px-0">
            <div class="card-login text-center">
              <router-link to="/login-veterinaire" class="my-4 icon-wrapper d-block">
                <img :src="icon1" width="78" height="88" />
              </router-link>
            </div>
          </div>
          <div class="col-lg-4 col-5 px-0">
            <div class="card-login text-center">
              <img :src="checked" class="checked-card" />

              <router-link to="/login-proprietaire" class="my-4 d-block icon-wrapper selected">
                <img :src="icon2" width="78" height="88" />
              </router-link>
            </div>
          </div>
        </div>

        <p class="title mb-3">
          Créez votre mot de passe pour accéder<br />
          à votre plateforme
        </p>

        <!-- Message d'information pour profil incomplet -->
        <div v-if="isProfileIncomplete" class="row justify-content-center mb-3">
          <div class="col-lg-10">
            <div class="alert alert-info">
              <strong>Profil incomplet</strong><br />
              Votre profil nécessite des informations supplémentaires pour accéder à la plateforme de votre vétérinaire.
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-10 my-2">
            <div class="mx-auto form-register d-flex flex-column">
              <!-- Champ email avec gestion du mode profil incomplet -->
              <div class="position-relative">
                <input
                  type="text"
                  v-model="user.email"
                  class="input-text w-100"
                  :class="{
                    'mb-2': errorEmail != '',
                    'mb-4': errorEmail == '',
                    'email-disabled': isProfileIncomplete
                  }"
                  placeholder="Adresse e-mail"
                  :disabled="isProfileIncomplete"
                />
                <div v-if="isProfileIncomplete" class="email-lock-info">
                  <small class="text-muted">Email verrouillé - profil incomplet</small>
                </div>
              </div>
              <span v-if="errorEmail" class="error-message mb-4">{{ errorEmail }}</span>
              
              <input
                type="text"
                v-model="user.code_clinique"
                class="input-text"
                :class="{
                  'mb-2': errorCode != '',
                  'mb-4': errorCode == '',
                }"
                placeholder="Code clinique"
              />
              <span v-if="errorCode" class="error-message mb-4">{{ errorCode }}</span>
              <button
                class="btn text-white btn-register w-100 mb-4"
                id="step1"
                @click.prevent="Inscrit"
                :disabled="isLoading"
              >
                {{ isProfileIncomplete ? 'Compléter mon profil' : 'Je m\'inscris' }}
              </button>
              <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
            </div>
            <router-link to="/login-proprietaire"
              ><label class="prev-step"> <img :src="prev" /> Étape précédente</label></router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import icon1 from "@/assets/images/icon_veterinaire.png";
  import icon2 from "@/assets/images/icon_proprietaire.png";
  import checked from "@/assets/images/check-box.png";
  import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
  import prev from "@/assets/images/icon-prev.svg";
  import { useRegisterStore } from "@/stores/register";
  import { registerProprietaire } from "@/api/auth";
  import $ from "jquery";

  export default {
    name: "AppHeader",
    data() {
      return {
        icon1,
        icon2,
        checked,
        logo,
        prev,
        user: {
          civilite: "",
          firstname: "",
          lastname: "",
          email: "",
          confirm_email: "",
          code_clinique: "",
          confirm_code_clinique: "",
          street: "",
          street2: "",
          city: "",
          postcode: "",
          countrycode: "FR",
          phonenumber: "",
          step: 1,
        },
        isLoading: false,
        errorMessage: "",
        errorEmail: "",
        errorCode: "",
        canStore: true,
        isProfileIncomplete: false, 
      };
    },
    mounted() {
      const store = useRegisterStore();
      this.user.email = store.user.email ?? "";
      this.user.code_clinique = store.user.code_clinique ?? "";
      this.isProfileIncomplete = store.isProfileIncomplete || false;
      if (this.isProfileIncomplete && store.user.email) {
        this.user.email = store.user.email;
      }
    },
    methods: {
       Inscrit() {
        this.errorMessage = "";
        this.errorEmail = "";
        this.errorCode = "";
        this.canStore = true;
        this.isLoading = true;
        
        var spinner =
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Chargement en cours ...';
        $("#step1").html(spinner);
        
        this.CheckValidate();
        
        // registration proprietaire step 1
        if (this.canStore) {
          const store = useRegisterStore();
          store.startRegistration(); // ← Début du processus
          
          registerProprietaire(this.user)
            .then(response => {
              $("#step1").text(this.isProfileIncomplete ? 'Compléter mon profil' : 'Je m\'inscris');
              this.isLoading = false;
              
              // Stocker la réponse complète de l'API dans le store
              if (response.data) {
                store.setApiResponse(response.data);
                
                // Si customer_exists est true, on utilise la nouvelle action
                if (response.data.customer_exists) {
                  store.setExistingCustomer(true);
                   store.setProfileIncomplete(true);
                  store.setUser({ 
                    email: this.user.email
                  });
                }
              }
              
           
              
              store.setStepOne({
                email: this.user.email,
                code_clinique: this.user.code_clinique,
              });
              store.setInfoveterinaire(response.data.clinique);
              this.$router.push({
                name: "proprietaire-register",
              });
            })
            .catch(res => {
              this.isLoading = false;
              store.cancelRegistration(); // ← Annulation en cas d'erreur
              this.errorMessage =
                res.response && res.response.data
                  ? res.response.data.msg
                  : "La clinique n'existe pas. Veuillez vérifier le code de la clinique";
              $("#step1").text(this.isProfileIncomplete ? 'Compléter mon profil' : 'Je m\'inscris');
            });
        }
      },
      CheckValidate() {
        if (this.user.email == "") {
          this.errorEmail = "Le champ email est obligatoire";
          this.canStore = false;
        } else {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!regex.test(this.user.email)) {
            this.errorEmail = "Format Email invalide";
            this.canStore = false;
          }
        }
        
        if (this.user.code_clinique == "") {
          this.errorCode = "Le champ code de clinique est obligatoire";
          this.canStore = false;
        }
        
        if (!this.canStore) {
          this.isLoading = false;
          $("#step1").text(this.isProfileIncomplete ? 'Compléter mon profil' : 'Je m\'inscris');
        }
      },
    },
  };
</script>
<style scoped>
  .register-body {
    position: relative;
    height: 100%;
  }
  .top-logo {
    text-align: end;
  }
  .top-logo img {
    margin-right: 20px;
  }

  .register-body .title {
    color: #1e347d;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 29px;
  }
  .register-body .slogan {
    font-size: 17px;
    color: #1e347d;
    text-align: center;
  }
  .cards-login {
    justify-content: center;
  }
  .card-login .title {
    color: #1e347d;
    font-size: 23px;
    font-weight: bold;
  }
  .register-body .icon-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
    margin: 0 auto;
    border: 2px solid #1e347d;
    border-radius: 10px;
  }
  .register-body .icon-wrapper.selected {
    background: #c9cfde 0% 0% no-repeat padding-box;
  }
  .register-body .checked-card {
    position: absolute;
    top: 5%;
  }
  .form-register {
    input {
      height: 40px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 2px solid #aeb1ba;
      border-radius: 76px;
      padding: 0 20px;
      transition: all 0.3s ease-in-out;
    }
    input:focus {
      border-color: #c9cfde;
      box-shadow: 0 0 8px #c9cfde;
      transform: scale(1.05);
      outline: none;
    }
    
    /* Style spécifique pour l'email en mode profil incomplet */
    .email-disabled {
      background-color: #f8f9fa;
      border-color: #dee2e6;
      color: #6c757d;
      cursor: not-allowed;
    }
  }
  
  .email-lock-info {
    position: absolute;
    top: -20px;
    left: 15px;
    font-size: 0.8rem;
  }
  
  .alert-info {
    background-color: #e7f3ff;
    border: 1px solid #b3d7ff;
    border-radius: 10px;
    padding: 12px 15px;
    color: #004085;
    font-size: 14px;
  }

  .btn-register {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 19px;
    text-align: center;
    font: normal normal bold 19px/25px DM Sans;
    letter-spacing: 0px;
  }
  .prev-step {
    font-size: 15px;
    color: #1e347d;
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  .error-message {
    color: red;
    margin-left: 8px;
  }
</style>